"use client";

import { c as _c } from "react/compiler-runtime";
import { Code, GithubIcon } from "lucide-react";
import Link from "next/link";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useAppConfig } from "@/lib/config";
import { useApi } from "@/lib/fetch-client";
function Newsletter() {
  const [email, setEmail] = useState("");
  const api = useApi();
  const subscribe = api.useMutation("post", "/public/newsletter/subscribe");
  return <div className="relative rounded-2xl border border-border/60 bg-gradient-to-b from-muted/40 to-muted/20 overflow-hidden mb-12">
			<div className="absolute top-0 inset-x-0 h-px bg-gradient-to-r from-transparent via-blue-500/40 to-transparent" />
			<div className="relative px-6 py-10 sm:px-10 sm:py-12">
				{subscribe.isSuccess ? <div className="flex flex-col items-center gap-4 text-center py-2">
						<div className="flex h-12 w-12 items-center justify-center rounded-full bg-green-500/10 ring-1 ring-green-500/20">
							<svg className="h-6 w-6 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
								<path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
							</svg>
						</div>
						<div className="space-y-1">
							<h3 className="text-xl font-bold">You&apos;re in!</h3>
							<p className="text-sm text-muted-foreground max-w-sm mx-auto">
								{subscribe.data?.message ?? "Check your inbox — we'll send you the good stuff, no filler."}
							</p>
						</div>
					</div> : <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-8 md:gap-12">
						<div className="flex-1 max-w-lg space-y-3">
							<p className="text-xs font-semibold uppercase tracking-widest text-blue-600 dark:text-blue-400">
								Newsletter
							</p>
							<h3 className="text-xl sm:text-2xl font-bold tracking-tight">
								Stay ahead of the curve
							</h3>
							<p className="text-sm text-muted-foreground leading-relaxed max-w-md">
								Join developers who get weekly insights on new models, cost
								optimization, and AI coding tips — straight to their inbox.
							</p>
						</div>
						<div className="w-full md:w-auto md:min-w-[300px]">
							<form className="flex flex-col gap-3" onSubmit={e => {
            e.preventDefault();
            if (subscribe.isPending) {
              return;
            }
            subscribe.mutate({
              body: {
                email
              }
            });
          }}>
								<Input type="email" placeholder="you@company.com" value={email} onChange={e_0 => setEmail(e_0.target.value)} required className="h-11 rounded-xl bg-background/80" />
								<Button type="submit" disabled={subscribe.isPending} className="h-11 rounded-xl">
									{subscribe.isPending ? "Subscribing..." : "Subscribe — it's free"}
								</Button>
								<p className="text-[11px] text-muted-foreground/60 text-center">
									No spam. Unsubscribe anytime.
								</p>
							</form>
							{subscribe.isError && <p className="mt-2 text-sm text-destructive text-center">
									Something went wrong. Please try again.
								</p>}
						</div>
					</div>}
			</div>
		</div>;
}
export function Footer() {
  const $ = _c(59);
  const config = useAppConfig();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Newsletter />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Link href="/" className="flex items-center gap-2"><div className="flex h-7 w-7 items-center justify-center rounded-lg bg-foreground text-background"><Code className="h-4 w-4" /></div><span className="font-semibold">DevPass</span></Link>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <GithubIcon className="h-5 w-5" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== config.githubUrl) {
    t3 = <a href={config.githubUrl} target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors" aria-label="GitHub">{t2}</a>;
    $[3] = config.githubUrl;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <svg className="h-5 w-5" viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" /></svg>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== config.twitterUrl) {
    t5 = <a href={config.twitterUrl} target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors" aria-label="X">{t4}</a>;
    $[6] = config.twitterUrl;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <svg className="h-5 w-5" viewBox="0 0 24 24" fill="currentColor"><path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028c.462-.63.874-1.295 1.226-1.994a.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z" /></svg>;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== config.discordUrl) {
    t7 = <a href={config.discordUrl} target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors" aria-label="Discord">{t6}</a>;
    $[9] = config.discordUrl;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t3 || $[12] !== t5 || $[13] !== t7) {
    t8 = <div>{t1}<div className="flex items-center gap-3 mt-4">{t3}{t5}{t7}</div></div>;
    $[11] = t3;
    $[12] = t5;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <h3 className="text-sm font-semibold mb-4 text-foreground">Product</h3>;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  let t11;
  let t12;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <li><Link href="/coding-models" className="text-sm hover:underline underline-offset-4 hover:text-foreground">Coding Models</Link></li>;
    t11 = <li><Link href="/pricing" className="text-sm hover:underline underline-offset-4 hover:text-foreground">Pricing</Link></li>;
    t12 = <li><Link href="/compare" className="text-sm hover:underline underline-offset-4 hover:text-foreground">Compare Plans</Link></li>;
    $[16] = t10;
    $[17] = t11;
    $[18] = t12;
  } else {
    t10 = $[16];
    t11 = $[17];
    t12 = $[18];
  }
  const t13 = `${config.uiUrl}/models`;
  let t14;
  if ($[19] !== t13) {
    t14 = <li><a href={t13} rel="noopener" target="_blank" className="text-sm hover:underline underline-offset-4 hover:text-foreground">All Models</a></li>;
    $[19] = t13;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] !== config.uiUrl) {
    t15 = <li><a href={config.uiUrl} rel="noopener" target="_blank" className="text-sm hover:underline underline-offset-4 hover:text-foreground">LLM Gateway</a></li>;
    $[21] = config.uiUrl;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] !== t14 || $[24] !== t15) {
    t16 = <div>{t9}<ul className="space-y-2">{t10}{t11}{t12}{t14}{t15}</ul></div>;
    $[23] = t14;
    $[24] = t15;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <h3 className="text-sm font-semibold mb-4 text-foreground">Resources</h3>;
    $[26] = t17;
  } else {
    t17 = $[26];
  }
  let t18;
  if ($[27] !== config.docsUrl) {
    t18 = <li><a href={config.docsUrl} target="_blank" rel="noopener" className="text-sm hover:underline underline-offset-4 hover:text-foreground">Documentation</a></li>;
    $[27] = config.docsUrl;
    $[28] = t18;
  } else {
    t18 = $[28];
  }
  const t19 = `${config.uiUrl}/integrations`;
  let t20;
  if ($[29] !== t19) {
    t20 = <li><a href={t19} target="_blank" rel="noopener" className="text-sm hover:underline underline-offset-4 hover:text-foreground">Integrations</a></li>;
    $[29] = t19;
    $[30] = t20;
  } else {
    t20 = $[30];
  }
  const t21 = `${config.uiUrl}/blog`;
  let t22;
  if ($[31] !== t21) {
    t22 = <li><a href={t21} target="_blank" rel="noopener" className="text-sm hover:underline underline-offset-4 hover:text-foreground">Blog</a></li>;
    $[31] = t21;
    $[32] = t22;
  } else {
    t22 = $[32];
  }
  let t23;
  if ($[33] !== t18 || $[34] !== t20 || $[35] !== t22) {
    t23 = <div>{t17}<ul className="space-y-2">{t18}{t20}{t22}</ul></div>;
    $[33] = t18;
    $[34] = t20;
    $[35] = t22;
    $[36] = t23;
  } else {
    t23 = $[36];
  }
  let t24;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <h3 className="text-sm font-semibold mb-4 text-foreground">Community</h3>;
    $[37] = t24;
  } else {
    t24 = $[37];
  }
  let t25;
  if ($[38] !== config.discordUrl) {
    t25 = <li><a href={config.discordUrl} target="_blank" rel="noopener noreferrer" className="text-sm hover:underline underline-offset-4 hover:text-foreground">Discord</a></li>;
    $[38] = config.discordUrl;
    $[39] = t25;
  } else {
    t25 = $[39];
  }
  let t26;
  if ($[40] !== config.twitterUrl) {
    t26 = <li><a href={config.twitterUrl} target="_blank" rel="noopener noreferrer" className="text-sm hover:underline underline-offset-4 hover:text-foreground">Twitter</a></li>;
    $[40] = config.twitterUrl;
    $[41] = t26;
  } else {
    t26 = $[41];
  }
  let t27;
  if ($[42] !== config.githubUrl) {
    t27 = <li><a href={config.githubUrl} target="_blank" rel="noopener noreferrer" className="text-sm hover:underline underline-offset-4 hover:text-foreground">GitHub</a></li>;
    $[42] = config.githubUrl;
    $[43] = t27;
  } else {
    t27 = $[43];
  }
  let t28;
  if ($[44] !== t25 || $[45] !== t26 || $[46] !== t27) {
    t28 = <div>{t24}<ul className="space-y-2">{t25}{t26}{t27}</ul></div>;
    $[44] = t25;
    $[45] = t26;
    $[46] = t27;
    $[47] = t28;
  } else {
    t28 = $[47];
  }
  let t29;
  if ($[48] !== t16 || $[49] !== t23 || $[50] !== t28) {
    t29 = <div className="grid grid-cols-2 gap-8 text-muted-foreground sm:grid-cols-3">{t16}{t23}{t28}</div>;
    $[48] = t16;
    $[49] = t23;
    $[50] = t28;
    $[51] = t29;
  } else {
    t29 = $[51];
  }
  let t30;
  if ($[52] !== t29 || $[53] !== t8) {
    t30 = <div className="flex flex-col md:flex-row md:justify-between md:items-start gap-8">{t8}{t29}</div>;
    $[52] = t29;
    $[53] = t8;
    $[54] = t30;
  } else {
    t30 = $[54];
  }
  let t31;
  if ($[55] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = <p className="text-muted-foreground text-sm">© {new Date().getFullYear()} LLM Gateway. All rights reserved.</p>;
    $[55] = t31;
  } else {
    t31 = $[55];
  }
  let t32;
  if ($[56] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = <div className="border-t border-border/50 pt-8 mt-8 flex flex-col sm:flex-row items-center justify-between gap-4">{t31}<div className="flex items-center gap-6"><Link href="/legal/privacy" className="text-sm text-muted-foreground hover:underline underline-offset-4 hover:text-foreground">Privacy Policy</Link><Link href="/legal/terms" className="text-sm text-muted-foreground hover:underline underline-offset-4 hover:text-foreground">Terms of Use</Link></div></div>;
    $[56] = t32;
  } else {
    t32 = $[56];
  }
  let t33;
  if ($[57] !== t30) {
    t33 = <footer className="relative border-t py-12 px-4"><div className="container mx-auto max-w-5xl">{t0}{t30}{t32}</div></footer>;
    $[57] = t30;
    $[58] = t33;
  } else {
    t33 = $[58];
  }
  return t33;
}